import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lighten } from 'polished';
import DividerLine from 'components/atoms/DividerLine';
import { ChannelSubHeader } from 'components/atoms/header/ChannelHeader';
import { objectives as objectiveNameMap } from 'constants/facebook';
import { LAYERTHREE } from 'constants/layers';

const defaultRowContentMargin = 32;
const topMargin = 55;
const DividerLineStyled = styled(DividerLine)`
    margin-top: ${topMargin}px;

    ${'' /* Sibling selector that reduces the margin if the dash line follows a row element.
        The items within the row element will have bottom margin that will not collapse
        with the maring-top of property of this element. So we just reduce this elements margin-top.
        */}
    .row + & {
        margin-top: ${topMargin - defaultRowContentMargin}px;
    }
`;

const ExpandModuleButton = styled.div`
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;
    background-color: #fff;
    border: 1px solid ${props => lighten(0.05, props.theme.colors.primary)};
    height: 50px;
    color: ${props => lighten(0.05, props.theme.colors.primary)};
    border-radius: 2px;
    outline: 0;
    font-size: 16px;
    transition: all 500ms ease-in-out;
    margin-bottom: 15px;
    cursor: pointer;
    display: ${props => (props.hide ? 'none' : 'flex')};
    
    @keyframes downarrow {
                0% { margin-top: 0px; }
                100% { margin-top: 8px;}
            }

    i {
        font-size: 24px;
        margin-top: 5px;
        color: ${props => lighten(0.05, props.theme.colors.primary)};
    }

    &.expandmodulebutton-hide {
        span {
            margin: 0px 10px;
        }
    }
    
    &.expandmodulebutton-show {
        span {
            margin: 0px 10px;
            margin-top: -5px;
        }
        
        &:hover {
            i {
                animation: downarrow 1s infinite;
                transition: all ease;
            }
        }
    }
`;


class SocialModule extends Component {
    render() {
        const { objective, children, expandContainer, hide,
            initialExpand, toggleExpand, layer = LAYERTHREE } = this.props;
        const expandButtonText = `${!hide ? 'Hide' : 'Show more about'} ${objectiveNameMap[objective]}`;
        const ExpandContainer = expandContainer;
        const showButton = (
            <ExpandModuleButton onClick={toggleExpand} className="expandmodulebutton-show">
                <i className='icon-arrow-dropdown' />
                <span>{expandButtonText}</span>
                <i className='icon-arrow-dropdown' />
            </ExpandModuleButton>);
        const hideButton = (
            <ExpandModuleButton onClick={toggleExpand} hide={hide} className="expandmodulebutton-hide">
                <i className='icon-arrow-dropup' />
                <span>{expandButtonText}</span>
                <i className='icon-arrow-dropup' />
            </ExpandModuleButton>);

        if (!children) {
            return null;
        }

        return (
            <React.Fragment>
                <DividerLineStyled />
                <ChannelSubHeader>
                    {objectiveNameMap[objective]}
                </ChannelSubHeader>

                {children}

                {initialExpand ?
                    <React.Fragment>
                        {hideButton}
                        <ExpandContainer hide={hide} objective={objective} layer={layer} />
                    </React.Fragment>
                    : null
                }
                {hide ?
                    showButton :
                    hideButton
                }

            </React.Fragment>
        );
    }
}

SocialModule.propTypes = {
    objective: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    campaigns: PropTypes.object.isRequired,
    hide: PropTypes.bool.isRequired,
    initialExpand: PropTypes.bool.isRequired,
    toggleExpand: PropTypes.func.isRequired
};

export default SocialModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/SocialModule.js